/*
We are using Segment for analytics. This file is a helper file that contains all the analytics events that we are tracking in the app.
These events all live in figma_plugin “space” so by default everything refers to figma plugin events.
Reference document: https://webflow.atlassian.net/wiki/x/NQCULg

Since every event has a different data structure, we need to pass the data object to the trackEvent function.
The data object is an object that contains all the data that we want to track for a specific event.
The data object is optional and can be passed as the second argument to the trackEvent function.
*/

import { eventsData } from './events';
import { AnalyticsBrowser } from '@segment/analytics-next';

import { getSyncDuration } from '@/helpers/helper';
import * as logger from '@/helpers/logger';
import { statsig, STATSIG_ANONYMOUS } from '@/helpers/featureflags';
export * from './events';

const analytics = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_KEY });

export const trackUser = (user) => {
  if (import.meta.env.MODE === 'development') {
    console.log('trackUser: ', user);
  }

  if (user) {
    const { id, email } = user;
    analytics.identify(id);
    logger.setUserId(id);
    statsig.updateUserSync({ userID: id, email });
  } else {
    analytics.identify(null);
    logger.clearUserId();
    statsig.updateUserSync(STATSIG_ANONYMOUS);
  }
};

export const createExportEventObject = (source, data, startTime, syncId) => {
  return {
    source,
    componentCount: data?.components?.length || 0,
    elementCount: data?.elements?.length || 0,
    variableCount: data?.variables?.length || 0,
    variableCollectionCount: data?.collections?.length || 0,
    variableModeCount: data?.modes?.length || 0,
    styleCount: data?.styles?.length || 0,
    imageCount: data?.images?.length || 0,
    syncDuration: getSyncDuration(startTime),
    syncId,
  };
};

export const createCopyEventObject = (layerType, startTime) => {
  return {
    layerType,
    copyDuration: getSyncDuration(startTime),
  };
};

export const trackEvent = (event, data) => {
  analytics.track(event, createEvent(event, data));
};

const createEvent = (event, data) => {
  return eventsData[event](data);
};
